import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { LearnerFormResponse, LearnerFormUpdateRequest } from "@eduviaos/shared";
import { api } from "@/lib/api";

/** Phase SC-22 — a tenant's team invite form, as the super admin sees it. */
export const teamFormKeys = {
  all: ["team-form"] as const,
  tenant: (slug: string) => [...teamFormKeys.all, slug] as const,
};

export function useTenantTeamForm(tenantSlug: string) {
  return useQuery<LearnerFormResponse>({
    queryKey: teamFormKeys.tenant(tenantSlug),
    queryFn: () => api.get<LearnerFormResponse>(`/super-admin/tenants/${tenantSlug}/team-form`),
    enabled: Boolean(tenantSlug),
    staleTime: 30_000,
  });
}

export function useUpdateTenantTeamForm(tenantSlug: string) {
  const qc = useQueryClient();
  return useMutation<LearnerFormResponse, Error, LearnerFormUpdateRequest>({
    mutationFn: (body) =>
      api.put<LearnerFormResponse>(`/super-admin/tenants/${tenantSlug}/team-form`, body),
    onSuccess: (form) => {
      qc.setQueryData(teamFormKeys.tenant(tenantSlug), form);
    },
  });
}
